import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { PaginationService } from '../PaginationService';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MatMenuTrigger } from '@angular/material/menu';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
@Component({
  selector: 'app-dms-root-folder',
  templateUrl: './dms-root-folder.component.html',
  styleUrls: ['./dms-root-folder.component.scss'],
})
export class DmsRootFolderComponent implements OnInit {

  isProcessing = false;
  folderListForDataGrid: any = [];
  folderData: any = {};
  searchValue: any;
  searchValue2: any;
  searchValue3: any;
  title: any = "";
  visibleEditButton: boolean = false;
  visibleAddButton: boolean = false;
  dropDownFordocumentTypeList: any = [];
  documentTypeDropdown: any = [];
  selectedDocumentType: any = [];
  selectedDocumentTypeValue: any;
  isShowAddFolderButton = false;
  operationFlag = "";
  breadCrumbList: any = [];
  comments: any;
  columnList: any = [];
  dropDownForSearchValue: any = [{
    displayExp: "Document No.",
    valueExp: "documentNo"
  }, {
    displayExp: "Document Name",
    valueExp: "documentName"
  }]
  uiDateFormat: any = 'dd-MMM-yyyy';
  uiDateTimeFormat: any = 'dd-MMM-yyyy HH:mm:ss'
  selectedSearchValue: any = [];
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService,) {
    this.selectedSearchValue = [{
      displayExp: "Document No.",
      valueExp: "documentNo"
    }]
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') ?? '{}');

    if (obj.uiDateFormat != undefined && obj.uiDateFormat != null) {
      this.uiDateFormat = obj.uiDateFormat.replace("DD", 'dd').replace("MON", "MMM").replace("YYYY", "yyyy");

    }
    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat.replace("DD", 'dd').replace("HH24:MI:SS", 'HH:mm:ss').replace("MON", "MMM").replace("YYYY", "yyyy");
    }
  }

  documentTypeSearchText: string = '';
  groupsSearchText: string = '';

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  @ViewChild('documentType') documentType: MatSelect;
  documentTypeSelection = false;

  toggleAllSelection(value: any) {
    if (value == 'documentType') {
      if (this.documentTypeSelection) this.documentType.options.forEach((item: MatOption) => item.select());
      else {
        this.documentType.options.forEach((item: MatOption) => item.deselect())
        this.selectedDocumentType = [];
      }

    }
  }

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('mapFolderPopup', { static: true }) mapFolderPopup: TemplateRef<any>;
  @ViewChild('searchedDocumentPopup', { static: true }) searchedDocumentPopup: TemplateRef<any>;
  @ViewChild('templatePopup', { static: true }) templatePopup: TemplateRef<any>;
  @ViewChild('addUserGroupPopup', { static: true }) addUserGroupPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleConfirm: MatDialogRef<TemplateRef<any>>;
  visibleMapFolderPopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchedDocumentPopup: MatDialogRef<TemplateRef<any>>;
  visibleTemplatePopup: MatDialogRef<TemplateRef<any>>;
  visibleAddUserGroupPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;

  visiblePropertiesPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('propertiesPopup', { static: true }) propertiesPopup: TemplateRef<any>;

  addAndEditPopupConfig = {
    width: '1000px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  mapFolderPopupConfig = {
    width: '80%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  searchedDocumentPopupConfig = {
    width: '80%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  templatePopupConfig = {
    width: '60%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  addUserGroupPopupConfig = {
    width: '60%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  propertiesPopupConfig = {
    width: '1200px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };
  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 4,
  };

  userGroupsList: any = [];
  userGroupsDropdown: any = [];
  selectedUserGroups: any = null;
  settingsObj: any = {};
  ngOnInit(): void {
    this.isProcessing = true;


    this.breadCrumbList = ["Documents", "Repository"];
    this.appService.getUserCountForFolderAuth().subscribe({
      next: (data: any) => {
        if (data > 0) {
          this.isShowAddFolderButton = true;
        } else {
          this.isShowAddFolderButton = false;
        }
      }, error: (error) => {
        this.isProcessing = false;
      }
    });


    this.appService.getDocumentTypeBasedOnModule("DOCS").subscribe({
      next: (data: any) => {
        this.dropDownFordocumentTypeList = data;
        this.documentTypeDropdown = this.dropDownFordocumentTypeList.map((type: any) => ({
          valueExp: type.documentTypeCode,
          displayExp: type.documentTypeName.trim()
        })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) || []

      }, error: (error) => {
        this.isProcessing = false;
      }
    });
    this.getcall();

    this.appService.getDmsGroupsVwDetails().subscribe({
      next: (data: any) => {
        this.userGroupsList = data;
        this.userGroupsDropdown = [];
        this.isProcessing = false;
        this.userGroupsDropdown = this.userGroupsList
          .filter((user: any) => user.isActive === 'Y')
          .map((user: any) => ({
            valueExp: user.groupId,
            displayExp: user.groupName.trim()
          }))
          .sort((m: any, n: any) => m.displayExp.localeCompare(n.displayExp)) || [];

      }, error: (error) => {
        this.isProcessing = false;
      }
    });
    this.appService.getDmsSettingVw().subscribe((data: any) => {
      this.settingsObj = data;
    })

  }

  getcall() {
    this.isProcessing = true;
    this.appService.getDmsFolderList(0).subscribe({
      next: (data: any) => {
        this.folderListForDataGrid = data;
        this.collectionSize = this.folderListForDataGrid.length;
        this.pager.totalPages = undefined;
        this.setPage(1, 0);
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
      }
    });
  }

  refreshPage() {
    this.getcall();
  }

  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  collectionForPopup: number;
  perPage = 10;
  perPage3 = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pager3: any = {};
  pagedItems: any[]; pagedItemsForPopup: any[];
  pagedItems2: any[];
  pagedItems3: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.folderListForDataGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.folderListForDataGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.folderListForDataGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.folderListForDataGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.folderListForDataGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  folderListForDataGridTemp: any = [];
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.folderListForDataGridTemp = this.folderListForDataGrid;
      this.collectionSize = this.folderListForDataGridTemp.length;
      this.pager = this.paginationService.getPager(this.folderListForDataGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.folderListForDataGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.folderListForDataGrid == undefined) {
        return this.folderListForDataGrid;
      }
      if (!this.folderListForDataGrid.length) {
        return this.folderListForDataGrid;
      }
      if (filter) {
        this.folderListForDataGridTemp = this.folderListForDataGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.folderListForDataGridTemp = this.folderListForDataGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.collectionSize = this.folderListForDataGridTemp.length;
      this.setPagedorserch(1, 0);
    }
  }

  setPageForPopup(page: number, targetpage: number, list: any) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(list.length, page, this.perPage, targetpage);
    this.pagedItemsForPopup = list.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall1(value: number, list: any) {
    this.perPage = value;
    this.setPageForPopup(this.pager.currentPage, 0, list);
  }

  templateList: any = [];
  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.templateList.length, page, this.perPage, targetpage);
    this.pagedItems2 = this.templateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }

  dmsGroupsList: any = [];
  setPage3(page: number, targetpage: number) {
    if (page < 1 || page > this.pager3.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager3 = this.paginationService.getPager(this.dmsGroupsList.length, page, this.perPage3, targetpage);
    this.pagedItems3 = this.dmsGroupsList.slice(this.pager3.startIndex, this.pager3.endIndex + 1);
  }

  paginationCall3(value: number) {
    this.perPage3 = value;
    this.setPage3(this.pager3.currentPage, 0);
  }

  addFolderFunc() {
    this.title = "Add Folder";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.folderData = {};
    this.folderData['folderName'] = "";
    this.folderData['folderDescription'] = null;
    this.folderData['documentTypeCode'] = null;
    this.folderData['parentFolderId'] = 0;
    this.folderData['folderCode'] = null;
    this.folderData['isDistributedFolder1'] = false;
    this.folderData['documentNoFormat'] = null;
    this.folderData['documentNoRegeneration'] = null;
    this.folderData['documentNoNoOfDigits'] = null;
    this.folderData['allowToInputDocumentNoManually1'] = false;
    this.folderData['allowToInputVersionManually1'] = false;
    this.folderData['enablePublishMailForFolderUsers1'] = false;

    this.folderData['overrideDocumentNumberFormatAtFolder'] = false;
    this.cascaseToChild = false;
    this.isDisableOverrideDocType = false;
    this.selectedDocumentType = [];
    this.selectedDocumentTypeValue = "";
    this.selectedUserGroups = null;
    this.operationFlag = "ADD";
    this.documentTypeSelection = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }
  isDisableOverrideDocType: boolean = false;
  ondocumentTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.documentTypeSelection = this.documentTypeDropdown.length == this.selectedDocumentType.length;
      })
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  folderName: any;
  folderNameRequiredMsg: any;

  updateReason: any;
  updateReasonRequiredMsg: any;
  fieldValidation() {
    this.folderName = document.getElementById('folderName') as HTMLInputElement;
    this.folderNameRequiredMsg = document.getElementById('folderName-required-msg') as HTMLInputElement;

    this.updateReason = document.getElementById('updateReason') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;

    if (this.folderData.folderName == "") {
      this.folderName.style.border = '1px solid red';
      this.folderNameRequiredMsg.style.display = 'block';
    } else {
      this.folderName.style.border = 'none';
      this.folderNameRequiredMsg.style.display = 'none';
    }

    if (this.visibleEditButton) {
      if (this.folderData.updateReason == "") {
        this.updateReason.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
      } else {
        this.updateReason.style.border = 'none';
        this.updateReasonRequiredMsg.style.display = 'none';
      }
    }
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;

  validateCodeFields(event: KeyboardEvent) {
    const forbiddenKeys = ['.', ' ', '/', '\\'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onDistributedFolderChange() {
    if (this.folderData.isDistributedFolder1) {
      this.selectedDocumentType = [];
      this.selectedDocumentTypeValue = "";
      this.folderData.allowToInputDocumentNoManually1 = false;
      this.folderData.allowToInputVersionManually1 = false;
      this.folderData.enablePublishMailForFolderUsers1 = false;
      this.folderData.overrideDocumentNumberFormatAtFolder = false;
      this.folderData.documentNoFormat = null;
      this.folderData.documentNoRegeneration = null;
      this.folderData.documentNoNoOfDigits = null;
    }
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  addAndEditFunction(folderData: any) {
    this.isProcessing = true;
    debugger;
    if (folderData.folderName == "" || (this.visibleEditButton && this.folderData.updateReason == "")) {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      if (this.operationFlag == 'ADD') {
        folderData.isDistributedFolder = this.folderData.isDistributedFolder1 ? 'Y' : 'N';
        folderData.allowToInputDocumentNoManually = this.folderData.allowToInputDocumentNoManually1 ? 'Y' : 'N';
        folderData.allowToInputVersionManually = this.folderData.allowToInputVersionManually1 ? 'Y' : 'N';
        folderData.enablePublishMailForFolderUsers = this.folderData.enablePublishMailForFolderUsers1 ? 'Y' : 'N';

        this.selectedDocumentTypeValue = this.selectedDocumentType.length ? this.selectedDocumentType.join(',') : null;

        folderData.documentTypeCode = this.selectedDocumentTypeValue;
        this.appService.createDmsFolder(folderData).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              let folderId = Response.folderId;

              if (this.selectedUserGroups) {
                this.isProcessing = true;
                let data = {
                  groupId: this.selectedUserGroups,
                  folderId: folderId,
                  cascaseToChild: this.cascaseToChild ? 'Y' : 'N',
                }
                this.appService.createDmsGruoupFolders(data).subscribe({
                  next: (Response: any) => {
                    this.isProcessing = true;
                    if (Response.resultType == 'S') {
                      this.visibleAddAndEditPopup.close();
                      this.isProcessing = true;
                      this.getcall();
                    } else {
                      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                        duration: 5000,
                        data: {
                          message: Response.result,
                          type: Response.resultType == 'S' ? 'Success' : 'Error',
                          buttonLabel: "Ok"
                        },
                        horizontalPosition: 'center',
                        verticalPosition: 'top',
                        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
                      });
                      sb.onAction().subscribe(() => {
                        sb.dismiss();
                      });
                    }

                  }, error: (error) => {
                    this.isProcessing = false;
                    throw error;
                  }
                });
              } else {
                this.visibleAddAndEditPopup.close();
                this.isProcessing = true;
                this.getcall();
              }

              /*  } */

              this.isProcessing = false;
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              //duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        delete folderData.createdOn;
        delete folderData.updatedOn;

        folderData.isDistributedFolder = this.folderData.isDistributedFolder1 ? 'Y' : 'N';
        folderData.allowToInputDocumentNoManually = this.folderData.allowToInputDocumentNoManually1 ? 'Y' : 'N';
        folderData.allowToInputVersionManually = this.folderData.allowToInputVersionManually1 ? 'Y' : 'N';
        folderData.enablePublishMailForFolderUsers = this.folderData.enablePublishMailForFolderUsers1 ? 'Y' : 'N';

        this.selectedDocumentTypeValue = this.selectedDocumentType.length ? this.selectedDocumentType.join(',') : null;

        folderData.documentTypeCode = this.selectedDocumentTypeValue;
        this.appService.updateDmsFolder(folderData).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.isProcessing = true;
              this.getcall();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              //duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }, error: (error: any) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });

      }
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);

  }

  goToSubfolderPage(event: any) {
    this.appService.setParentFolderId(event.folderId);
    this.breadCrumbList.push(event.folderName);
    this.appService.setDocumentBreadcrumbList(this.breadCrumbList);
    this.router.navigate(['/dashboard/subFolder', event.folderName]);
  }
  menuTopLeftPosition = { x: '0', y: '0' }
  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;

  rightClickFolderData: any = {};
  actionLabels: any = [];
  onRightClick(event: MouseEvent, item: any) {
    // preventDefault avoids to show the visualization of the right-click menu of the browser
    event.preventDefault();
    this.rightClickFolderData = item;
    // we record the mouse position in our object
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';
    let data = {

      folderId: item.folderId,
      status: item.status
    }
    this.appService.getFolderActionLabels(data).subscribe((data: any) => {
      let actionLabels = data.actionLabels ? data.actionLabels.split(",") : [];
      let uiActionLabels = data.uiActionLabels ? data.uiActionLabels.split(",") : [];
      this.actionLabels = [];
      const iconMap: Record<string, string> = {
        "Delete": "fa fa-trash",
        "Inactivate": "fa fa-ban",
        "Activate": "Activelogo",
        "Lock": "fa fa-lock",
        "Unlock": "fa fa-unlock",
        "Additional Notification": "fa fa-flag-o",
        "Revoke Privileges": "removeUser",
        "Quality Check": "Auditimg",
        "Raise Query": "monitorauditrisequery",
        "Sticky Note": "strickynote",
        "Export": "ExporDocuments",
        "Update Status": "UpdateStatus",
        "Distribute": "Distribute",
        "Pin": "fa  fa-thumb-tack",
        "Unpin": "fa  fa-thumb-tack"
      };

      for (const label of actionLabels ?? []) {
        if (label) {
          this.actionLabels.push({
            text: label,
            icons: iconMap[label]
          });
        }
      }
      const uiIconMap: Record<string, string> = {
        "Properties": "fa fa-ellipsis-v",
        "Delete": "fa fa-trash",
        "Template": "fa fa-file-text-o",
        "Map Folder": "fa fa-folder",
        "Edit": "fa fa-pencil",
        "View History": "fa fa-history",
        "Add Usergroup": "addUser",
        "Audit Trail": "fa-solid fa-clipboard",
        "Tag to Home": "fa fa-tag"
      };

      for (const label of uiActionLabels ?? []) {
        if (label) {
          this.actionLabels.push({
            text: label,
            icons: uiIconMap[label]
          });
        }
      }
      this.matMenuTrigger.menuData = { item: this.actionLabels };
      this.matMenuTrigger.openMenu();
    })

  }

  @ViewChild(HomepagetagComponent) homepagetagComponent!: HomepagetagComponent;
  openTag(value: any) {
    let data = {
      pageName: 'Folder',
      labelName: "Tag",
      taskId: value.folderId,
      tagRef: value.folderCode == null ? value.folderName : value.folderCode + "-" + value.folderName
    };
    this.homepagetagComponent.openpopup(data);
  }

  onTagChildValueEmitted() {
  };

  deleteReason: any = "";
  buttonData: any;
  cascaseToChild: boolean = false;
  oddDocumentType: any = [];
  performOperationFunc(button: any) {
    this.buttonData = button;
    if (button.text == 'Tag to Home') {
      this.openTag(this.rightClickFolderData);
    } else if (button.text == "Edit") {
      this.title = "Edit Folder";
      this.visibleAddButton = false;
      this.visibleEditButton = true;
      this.selectedDocumentType = [];
      this.selectedDocumentTypeValue = "";
      this.appService.getDmsFolderDataById(this.rightClickFolderData.folderId)
        .subscribe((data: any) => {
          this.folderData = data[0];
          this.folderData.updateReason = "";
          this.folderData.isDistributedFolder = this.folderData.isDistributedFolder == "Y";
          this.folderData.allowToInputDocumentNoManually1 = this.folderData.allowToInputDocumentNoManually == "Y";
          this.folderData.allowToInputVersionManually1 = this.folderData.allowToInputVersionManually == "Y";
          this.folderData.enablePublishMailForFolderUsers1 = this.folderData.enablePublishMailForFolderUsers == "Y";

          this.folderData.isDistributedFolder1 = this.folderData.isDistributedFolder;
          if (this.folderData.documentNoFormat != null || this.folderData.documentNoRegeneration != null || this.folderData.documentNoNoOfDigits != null) {
            this.folderData.overrideDocumentNumberFormatAtFolder = true;
          } else {
            this.folderData.overrideDocumentNumberFormatAtFolder = false;
          }
          if (this.folderData.documentTypeCode) {
            this.selectedDocumentType = this.folderData.documentTypeCode.split(",");
            for (const _docType of this.selectedDocumentType ?? []) {
              const _matchingDocumentType = this.documentTypeDropdown?.find(
                (item: any) => item.valueExp === this.folderData.documentTypeCode
              );

              this.oddDocumentType = this.folderData.documentTypeCode;
            }

          }
        })

      this.operationFlag = "EDIT";
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    } else if (button.text == "Delete" || button.text == "Lock" || button.text == "Unlock" || button.text == "Inactivate"
      || button.text == "Activate") {
      this.title = button.text;
      this.comments = "";
      this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
    } else if (button.text == "Properties") {
      this.isProcessing = true;
      this.columnList = [{ "name": "Group", "width": "350px" }, { "name": "Priviledge Type", "width": "300px" }, { "name": "Assigned On", "width": "250px" },
      { "name": "Assigned By", "width": "250px" }]
      this.appService.getGroupPrivForFolders(this.rightClickFolderData['folderId'])
        .subscribe((data: any) => {
          this.groupAllFolderList = data;
          this.isProcessing = false;
          this.collectionForPopup = this.groupAllFolderList.length;
          this.pager.totalPages = undefined;
          this.setPageForPopup(1, 0, this.groupAllFolderList);
        })
      this.visiblePropertiesPopup = this.dialog.open(this.propertiesPopup, this.propertiesPopupConfig);
    } else if (button.text == "Map Folder") {
      this.isProcessing = true;
      this.appService.getDmsFolderDataById(this.rightClickFolderData.folderId)
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.folderData = data[0];
        })
      this.visibleMapFolderPopup = this.dialog.open(this.mapFolderPopup, this.mapFolderPopupConfig);
    } else if (button.text == "Template") {
      this.columnList = [{ "name": "Template Name", "width": "200px" }, { "name": "Template", "width": "120px" }, { "name": "Template Extn", "width": "150px" },
      { "name": "Is Active?", "width": "150px" }]
      this.isProcessing = true;
      this.appService.getDocumentTemplateByFolderId(this.rightClickFolderData.folderId,
      ).subscribe((data: any) => {
        this.isProcessing = false;
        this.templateList = data;
        this.collectionForPopup = this.templateList.length;
        this.pager.totalPages = undefined;
        this.setPageForPopup(1, 0, this.templateList);
        this.multiTemplateArray = [];
        this.visibleTemplatePopup = this.dialog.open(this.templatePopup, this.templatePopupConfig);
      })
    } else if (button.text == "Add Usergroup") {
      this.columnList = [{ "name": "Group Name", "width": "120px" }, { "name": "Description", "width": "300px" }, { "name": "Is Active?", "width": "100px" }]
      this.cascaseToChild = false;
      this.isProcessing = true;
      this.searchValue1 = '';
      this.searchValue3 = '';
      this.appService.getUserGroupsForFolders(this.rightClickFolderData.folderId).subscribe((data: any) => {
        this.isProcessing = false;
        this.dmsGroupsList = data;
        this.collectionForPopup = this.dmsGroupsList.length;
        this.pager.totalPages = undefined;
        this.setPageForPopup(1, 0, this.dmsGroupsList);
        this.visibleAddUserGroupPopup = this.dialog.open(this.addUserGroupPopup, this.addUserGroupPopupConfig);
      })
    } else if (button.text == "Audit Trail") {
      this.openAuditTrail('individual', this.rightClickFolderData.folderId);
    }
  }

  containsObject(obj: any, list: any) {
    let i;
    for (i = 0; i < list.length; i++) {
      if (list[i] === obj) {
        return true;
      }
    }

    return false;
  }

  applyFilter3(column: string, event: Event, list: any): void {
    if (column == "Group") { column = "groupName" }
    if (column == "Assigned By") { column = "assignedByName" }
    if (column == "Assigned On") { column = "assignedOn" }
    if (column == "Priviledge Type") { column = "priviledgeType" }
    if (column == "User or Role") { column = "userOrRoleName" }
    if (column == "Template Name") { column = "templateName" }
    if (column == "Template Extn") { column = "templateExtn" }
    if (column == "Group Name") { column = "groupName" }
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItemsForPopup = list.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItemsForPopup = list.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }



  cancelMapFolder() {
    this.visibleMapFolderPopup.close();
  }

  commentsCss: any;
  commnetsCssRequiredMsg: any;
  operationFieldValidation() {
    this.commentsCss = document.getElementById('comments') as HTMLInputElement;
    this.commnetsCssRequiredMsg = document.getElementById('comments-required-msg') as HTMLInputElement;

    if (this.comments == "") {
      this.commentsCss.style.border = '1px solid red';
      this.commnetsCssRequiredMsg.style.display = 'block';
    } else {
      this.commentsCss.style.border = 'none';
      this.commnetsCssRequiredMsg.style.display = 'none';
    }
  }

  groupAllFolderList: any = [];
  groupUsersAllFolderList: any = [];
  confirmOkFunc() {
    this.isProcessing = true;
    if (this.comments == "") {
      this.operationFieldValidation();
      this.isProcessing = false;
    } else {
      let data = {

        folderId: this.rightClickFolderData['folderId'],
        status: this.rightClickFolderData['status'],
        action: this.buttonData.text,
        comments: this.comments,
      }
      this.appService.performOperationForFolder(data).subscribe({
        next: (Response: any) => {
          this.isProcessing = false;
          this.visibleConfirm.close();
          if (Response.resultType == "S") {

            this.isProcessing = true;
            this.getcall();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
        }
      });
    }

  }

  cancelConfirmFunc() {
    this.visibleConfirm.close();
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }
  deleteFiledValue: any;
  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteReason == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteFunction() {
    this.isProcessing = true;
    if (this.deleteReason == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      delete this.folderData.createdOn;
      delete this.folderData.updatedOn;
      this.folderData.isDistributedFolder = this.folderData.isDistributedFolder ? "Y" : "N";
      this.folderData.deleteReason = this.deleteReason;
      this.appService.deleteDmsFolder(this.folderData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcall();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancelPropertiesPopupFunction() {
    this.visiblePropertiesPopup.close();
  }

  onTabChanged($event: any) {
    let data = $event.tab.textLabel;
    this.tabName = data;
    if (data == "Folder User Privilege") {
      this.columnList = [{ "name": "User or Role", "width": "200px" }, { "name": "Folder Administrator", "width": "150px" }, { "name": "Author", "width": "100px" },
      { "name": "Reviewer", "width": "100px" }, { "name": "Approver", "width": "100px" }, { "name": "QA", "width": "100px" }, { "name": "Training Coordinator", "width": "100px" },
      { "name": "Publisher", "width": "100px" }, { "name": "Blinded", "width": "100px" }, { "name": "Blindbreak", "width": "100px" }, { "name": "Redactor", "width": "100px" },
      { "name": "Downloader", "width": "100px" }, { "name": "Viewer", "width": "100px" }, { "name": "Authorizer", "width": "100px" }, { "name": "Extension Reviewer", "width": "140px" },
      { "name": "Extension Approver", "width": "140px" }, { "name": "Withdrawal Reviewer", "width": "140px" }, { "name": "Withdrawal Approver", "width": "140px" }, { "name": "Destruction Reviewer", "width": "150px" },
      { "name": "Destruction Approver", "width": "150px" }, { "name": "Printer", "width": "100px" },
      { "name": "Current Version Viewer", "width": "160px" }]
      if (this.groupUsersAllFolderList.length == 0) {
        this.isProcessing = true;
        this.appService.getGroupUserPrivForFolders(this.rightClickFolderData['folderId'])
          .subscribe((data: any) => {
            this.groupUsersAllFolderList = data;
            this.isProcessing = false;
            this.collectionForPopup = this.groupUsersAllFolderList.length;
            this.pager.totalPages = undefined;
            this.setPageForPopup(1, 0, this.groupUsersAllFolderList);
          })
      } else {

        this.collectionForPopup = this.groupUsersAllFolderList.length;
        this.pager.totalPages = undefined;
        this.setPageForPopup(1, 0, this.groupUsersAllFolderList);
      }

    } else {
      this.columnList = [{ "name": "Group", "width": "350px" }, { "name": "Priviledge Type", "width": "300px" }, { "name": "Assigned On", "width": "250px" },
      { "name": "Assigned By", "width": "250px" }]
      this.collectionForPopup = this.groupAllFolderList.length;
      this.pager.totalPages = undefined;
      this.setPageForPopup(1, 0, this.groupAllFolderList);
    }
  }
  docIdOrName: any = "";
  searchedDocumentsList: any = [];
  searchDocuments() {
    this.searchedDocumentsList = [];
    let data: any = {};
    if (this.selectedSearchValue[0].valueExp == "documentNo") {
      data['documentNo'] = this.docIdOrName;
      data['documentName'] = "undefined"
    } else {
      data['documentNo'] = "undefined";
      data['documentName'] = this.docIdOrName;
    }
    this.isProcessing = true;
    this.appService.searchDocumentsBasedOnCondition(data).subscribe((data: any) => {
      this.isProcessing = false;
      this.searchedDocumentsList = data;
      this.collectionSize = this.searchedDocumentsList.length;
      this.pager.totalPages = undefined;
      this.visibleSearchedDocumentPopup = this.dialog.open(this.searchedDocumentPopup, this.searchedDocumentPopupConfig);
    })

  }

  searchValue1: any;
  cancelSearchedDocumentPopup() {
    this.visibleSearchedDocumentPopup.close();
  }

  goToSubfolderPageFromSearchedDoc(doc: any) {
    this.visibleSearchedDocumentPopup.close();
    this.appService.setParentFolderId(doc.folderId);
    let breadCrumb = doc.folderPath.split(">");
    for (const item of breadCrumb ?? []) {
      this.breadCrumbList.push(item);
    }
    this.appService.setDocumentBreadcrumbList(this.breadCrumbList);
    this.router.navigate(['/dashboard/subFolder', doc.folderName]);
  }
  reason: any;

  canceltemplatePopup() {
    this.visibleTemplatePopup.close();
  }

  cancelAddUserGroupPopup() {
    this.visibleAddUserGroupPopup.close();
  }

  selectedUserGroup: any = {};
  previousSelectedData: any = {};
  dataGridGroupChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.grouptChildCheckBoxs = true;
      this.selectedUserGroup = list;
      this.previousSelectedData.grouptChildCheckBoxs = false;
    } else {
      list.grouptChildCheckBoxs = false;
      this.selectedUserGroup = {};
    }
    this.previousSelectedData = list;

  }

  addUserGroupFunc() {
    this.isProcessing = true;
    let data = {
      groupId: this.selectedUserGroup.groupId,
      folderId: this.rightClickFolderData.folderId,
      cascaseToChild: this.cascaseToChild ? 'Y' : 'N',
    }
    this.appService.createDmsGruoupFolders(data).subscribe({
      next: (Response: any) => {
        this.isProcessing = true;
        if (Response.resultType == 'S') {
          this.visibleAddUserGroupPopup.close();
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(viewType: any, folder: any) {
    // Standard setup
    this.message.tableOrView_Name = "DMS_FOLDERS_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,STATUS,DOCUMENT_TYPE_CODE,FOLDER_CODE,FOLDER_DESCRIPTION,FOLDER_NAME,FOLDER_PATH,IS_DISTRIBUTED_FOLDER,ALLOW_TO_INPUT_DOCUMENT_NO_MANUALLY,ALLOW_TO_INPUT_VERSION_MANUALLY,ENABLE_PUBLISH_MAIL_FOR_FOLDER_USERS,DOCUMENT_NO_FORMAT,DOCUMENT_NO_REGENERATION,DOCUMENT_NO_NO_OF_DIGITS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON,DELETED_BY_USER,DELETED_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Status,Document Type Code,Folder Code,Folder Description,Folder Name,Folder Path,Is Distributed Folder,Allow To Input Document No Manually,Allow To Input Version Manually,Enable Publish Mail For Folder Users,Document No Format,Document No Regeneration,Document No Of Digits,Created On,Created By,Updated On,Updated By,Update Reason,Deleted By,Deleted Reason";
    this.message.columnList_Report = this.message.columnList_UI;

    if (viewType == 'overAll') {
      this.message.whereClause_AU = "";
      this.message.whereClause_Report = "";
      this.message.report_And_Popup_Name = "Root Folder Audit Trail";
    } else {
      const filter = " AND FOLDER_ID=" + folder;

      this.message.whereClause_AU = filter;
      this.message.whereClause_Report = "FOLDER_ID=" + folder;
      this.message.report_And_Popup_Name = "Folder Audit Trail - " + this.rightClickFolderData.folderName;
    }

    this.staticAuditTrailComponent.triggerTrail(folder);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "DMS_CURRENT_FOLDER_VW";
    this.excelPdf.columnList_DB = "STATUS,DOCUMENT_TYPE_CODE,FOLDER_CODE,FOLDER_DESCRIPTION,FOLDER_NAME,FOLDER_PATH,IS_DISTRIBUTED_FOLDER,ALLOW_TO_INPUT_DOCUMENT_NO_MANUALLY,ALLOW_TO_INPUT_VERSION_MANUALLY,ENABLE_PUBLISH_MAIL_FOR_FOLDER_USERS,DOCUMENT_NO_FORMAT,DOCUMENT_NO_REGENERATION,DOCUMENT_NO_NO_OF_DIGITS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
    this.excelPdf.columnList_Report = "Status,Document Type Code,Folder Code,Folder Description,Folder Name,Folder Path,Is Distributed Folder,Allow To Input Document No Manually,Allow To Input Version Manually,Enable Publish Mail For Folder Users,Document No Format,Document No Regeneration,Document No Of Digits,Created On,Created By,Updated On,Updated By,Update Reason";
    this.excelPdf.whereClause_Report = " WHERE PARENT_FOLDER_ID = " + 0
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Root Folder Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

  visibleDownloadTemplatePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('downloadTemplatePopup', { static: true }) downloadTemplatePopup: TemplateRef<any>;

  downloadTemplatePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  bulkselectedTemplateData: any;
  selectedTemplateData: any;
  downloadType: any;
  downloadTemplates(list: any) {
    this.downloadType = "single";
    this.visibleTemplatePopup.close();
    this.selectedTemplateData = list;
    this.reason = "";
    this.visibleDownloadTemplatePopup = this.dialog.open(this.downloadTemplatePopup, this.downloadTemplatePopupConfig);

  }
  bulkDownloadTemplates() {
    this.downloadType = "bulk";
    this.visibleTemplatePopup.close();
    this.bulkselectedTemplateData = this.templateList[0];
    this.reason = "";

    this.visibleDownloadTemplatePopup = this.dialog.open(this.downloadTemplatePopup, this.downloadTemplatePopupConfig);

  }
  downloadTemplateForFolder() {
    if (!this.validateDownloadReason()) {
      return;
    }
    let object = {

      documentId: this.selectedTemplateData.templateId,
      version: 0,
      folderId: this.rightClickFolderData.folderId,
      issuanceType: "Download Template",
      associatedDocuments: "N",
      publisherDetails: null,
      comments: this.reason,
      issuanceId: null,
      templateId: this.selectedTemplateData.templateId,
      otherDetails: this.selectedTemplateData.templateName
    }

    this.isProcessing = true;
    this.appService.downloadDocumentTemplate(object).subscribe(
      (response: any) => {
        this.visibleDownloadTemplatePopup.close();
        let contentData = "data:application/octet-stream;base64," + this.selectedTemplateData.template;
        let downloadLink = document.createElement("a");
        downloadLink.href = contentData;
        downloadLink.download = this.selectedTemplateData.templateName + "." + this.selectedTemplateData.templateExtn;
        downloadLink.click()
        this.isProcessing = false;
      })



  }

  cancelDownloadTemplateFunc() {
    this.visibleDownloadTemplatePopup.close();
  }
  multiTemplateArray: any = [];
  searchTemplateParentCheckBox: boolean = false;
  selectAllTemplate(e: any) {
    this.searchTemplateParentCheckBox = e.target.checked;
    this.multiTemplateArray = [];

    if (e.target.checked) {
      this.templateList.forEach((templates: any) => {
        if (templates.templateName) {
          templates.searchTemplateChildCheckBox = true;

          this.multiTemplateArray.push({
            templateId: templates.templateId,
            templateName: templates.templateName,
            template: templates.template,
            templateExtn: templates.templateExtn,
            folderId: templates.folderId
          });
        }
      });
    } else {
      this.templateList.forEach((template: any) => {
        template.searchTemplateChildCheckBox = false;
      });
      this.multiTemplateArray = [];
    }
  }

  onChildCheckBoxChanged(e: any, listOfTemplateData: any, idx: any) {
    listOfTemplateData.searchTemplateChildCheckBox = e.target.checked;

    if (e.target.checked) {
      if (!this.multiTemplateArray.some((storedTemplate: any) => storedTemplate.templateId === listOfTemplateData.templateId)) {
        this.multiTemplateArray.push({
          templateId: listOfTemplateData.templateId,
          templateName: listOfTemplateData.templateName,
          template: listOfTemplateData.template,
          templateExtn: listOfTemplateData.templateExtn,
          folderId: listOfTemplateData.folderId
        });
      }
    } else {
      this.multiTemplateArray = this.multiTemplateArray.filter((item: any) => item.templateId !== listOfTemplateData.templateId);
    }
    this.searchTemplateParentCheckBox = this.templateList.length > 0 &&
      this.templateList.every((item: any) => item.searchTemplateChildCheckBox === true);
  }

  bulkDownloadTemplateForFolder(): void {
    if (!this.validateDownloadReason()) {
      return;
    }

    if (this.multiTemplateArray.length > 15) {
      alert("You cannot select more than 15 templates.");
    } else {
      this.isProcessing = true;
      let completedCount = 0;


      // Refactored to for...of loop to resolve Sonar S4138
      for (const template of this.multiTemplateArray ?? []) {
        const payload = {

          documentId: template.templateId,
          version: 0,
          folderId: this.rightClickFolderData?.folderId,
          issuanceType: "Download Template",
          associatedDocuments: "N",
          publisherDetails: null,
          comments: this.reason,
          issuanceId: null,
          templateId: template.templateId,
          otherDetails: template.templateName,
          downloadedFileName: template.templateName
        };

        // Refactored deprecated .subscribe() to use the observer object
        this.appService.downloadDocumentTemplate(payload).subscribe({
          next: (response) => {
            const contentData = `data:application/octet-stream;base64,${template.template}`;
            const downloadLink = document.createElement("a");
            downloadLink.href = contentData;
            downloadLink.download = `${template.templateName}.${template.templateExtn}`;
            downloadLink.click();

            completedCount++;
            if (completedCount === this.multiTemplateArray.length) {
              this.isProcessing = false;
              this.visibleDownloadTemplatePopup.close();
            }
          },
          error: (error) => {
            console.error(error);
            this.isProcessing = false;
            completedCount++;
            if (completedCount === this.multiTemplateArray.length) {
              this.visibleDownloadTemplatePopup.close();
            }
          }
        });
      }
    }
  }
  validateDownloadReason() {
    const reasonInput = document.getElementById('downloadReason') as HTMLInputElement;
    const reasonMsg = document.getElementById('downloadReason-required-msg') as HTMLInputElement;

    if (this.reason == "" || this.reason == null || this.reason.trim() == "") {
      if (reasonInput) reasonInput.style.border = '1px solid red';
      if (reasonMsg) reasonMsg.style.display = 'block';
      return false;
    } else {
      if (reasonInput) reasonInput.style.border = '';
      if (reasonMsg) reasonMsg.style.display = 'none';
      return true;
    }
  }



  reportObj: any = {};
  manuallyPicked: boolean;
  pdfSearchText: string = '';
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  selectedColumns: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup1', { static: true }) excelPdfPopup1: TemplateRef<any>;

  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  isSaveReport: boolean = false;
  reportName: any;
  tabName = "Folder Group Privilege";
  openReportProperties(reportType: string) {
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.popupDataTitle.title = 'Excel Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup1, this.excelPdfPopupConfig);
    this.isSaveReport = false;


  }
  popupDataTitle: any = {};
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";

  }
  whereValsForExcel: any;
  generateReport(value: any) {
    let invisibleList = "";

    this.appService.isProcessingRep = true;
    let tname = "";
    let colList = "";
    let fieldList = "";

    if (this.tabName == "Folder User Privilege") {
      this.whereValsForExcel = "";
      tname = "DMS_GROUP_USERS_ALL_FOLDER_PRIV_VW";
      colList = "USER_OR_ROLE_NAME, FOLDER_ADMINISTRATOR, AUTHOR, REVIEWER, APPROVER, QA, TRAINING_COORDINATOR, PUBLISHER, BLINDED, BLINDBREAK, REDACTOR, DOWNLOADER, VIEWER, AUTHORIZER, EXTENSION_REVIEWER, EXTENSION_APPROVER, WITHDRAWAL_REVIEWER, WITHDRAWAL_APPROVER, DESTRUCTION_REVIEWER, DESTRUCTION_APPROVER, PRINTER, CURRENT_VERSION_VIEWER";
      fieldList = "User or Role, Folder Administrator, Author, Reviewer, Approver, QA, Training Coordinator, Publisher, Blinded, Blindbreak, Redactor, Downloader, Viewer, Authorizer, Extension Reviewer, Extension Approver, Withdrawal Reviewer, Withdrawal Approver, Destruction Reviewer, Destruction Approver, Printer, Current Version Viewer";
      this.whereValsForExcel = " Where ORG_ID=" + this.message.getOrgId() + " AND FOLDER_ID=" + this.rightClickFolderData['folderId'];
    } else {
      this.whereValsForExcel = "";
      tname = "DMS_GROUP_ALL_FOLDERS_PRIV_VW";
      colList = "GROUP_NAME,PRIVILEDGE_TYPE,ASSIGNED_ON,ASSIGNED_BYNAME";
      fieldList = "Group Name,Priviledge Type,Assigned On,Assigned By";
      this.whereValsForExcel = " Where ORG_ID=" + this.message.getOrgId() + " AND FOLDER_ID=" + this.rightClickFolderData['folderId'];
    }

    const data1: any = {
      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: invisibleList,
      orderByClause: tname == "DMS_GROUP_USERS_ALL_FOLDER_PRIV_VW" ? "USER_OR_ROLE_NAME" : "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: null,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: null,
      chartStatus: "null",
      reModule: "qms1",
      logoId: 0,
      isSaveRep: this.isSaveReport ? 'Y' : 'N',
      footer: null,
      reportName: this.reportName,
      currentStatus: "NA",
      groupName: null,
      wherVal: this.whereValsForExcel
    }


    this.reportObj = { ...data1 };




    const fileName = "Report";

    const pdfData = {
      ...this.reportObj, title: "Report", columns: [],
      "informationTab": {
        "Report Name": "Report",
        "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
      }
    }
    this.appService.downloadexcelForChart(pdfData, fileName + ".xlsx");


  }
}
